<template>
    <div class="classic-book-website">
      <!-- 第二区域：全站搜索区 -->
      <section class="search-section">
        <div class="container search-container">
          <div class="search-box classic-border">
            <div class="search-icon">
              <!-- <i class="el-icon-search"></i> -->
              <i class="fas fa-search"></i>
            </div>
            <el-input
              v-model="searchKeyword"
              class="search-input"
              :placeholder="searchDefault"
              @keyup.enter.native="handleSearch"
            />
            <el-button class="search-button" @click="handleSearch">搜索</el-button>
          </div>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ClassicBookWebsite',
    data() {
      return {
        searchKeyword: '',
        searchDefault: '请输入书名、正文内容等关键词进行检索...',
        isMobile: false,
        showMobileCategories: false,
      }
    },
    computed: {

    },
    mounted() {
      this.checkScreenWidth()
    },
    beforeDestroy() {
    
    },
    methods: {
      // 获取当前路由信息
      getCurrentRoute() {
        const route = this.$route;
        return route.name;
      },

      handleSearch() {
        if (this.searchKeyword.trim()) {
          /* this.$message({
            message: `正在搜索: ${this.searchKeyword}`,
            type: 'info'
          }) */
          let _self = this
          // _self.$router.push({path:'/searchpage',query: {type:'1'}})
          _self.$router.push({
            path: '/searchpage',
            query: { type: '1', searchtext: this.searchKeyword }
          }).then(() => {
            window.scrollTo(0, 0)
          })
        } else {
          this.$message({
            message: '请输入搜索关键词',
            type: 'warning'
          })
        }
      },
    
      handleImageError(e) {
        console.error('Logo图片加载失败')
        e.target.style.display = 'none'
      },
    
      // 返回上级界面(首页)
      goBackPage(){
        let pagename = this.getCurrentRoute()
        if(pagename != 'hoem'){   //非首页界面，才返回上级首页
          //this.$router.go(-1)
          let _self = this
          _self.$router.push({path:'/',query: {type:'1'}})
        }
      },
      checkScreenWidth() {
        this.isMobile = window.innerWidth <= 768
        if(this.isMobile){
          this.searchDefault='输入书名、正文等关键词检索...';
        }
      },
    }
  }
  </script>
  
  <style scoped>
  /* 引入外部字体和图标库 20260105*/
  @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');
  @import url('https://fonts.googleapis.com/css2?family=Ma+Shan+Zheng&family=Noto+Serif+SC:wght@400;600;700&display=swap');

  /* 基础样式重置与古典风格定义 */
  * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
  }
  
  body {
      font-family: 'Noto Serif SC', serif;
      line-height: 1.6;
      color: #5c3a21;
      background-color: #f5f0e6; /* 古典纸张背景色 */
      background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%239C8B7E' fill-opacity='0.08' fill-rule='evenodd'/%3E%3C/svg%3E");
      min-height: 100vh;
      overflow-x: hidden;
  }
  
  .container {
      width: 100%;
      /* max-width: 1200px; 20260107，增加界面的宽度*/
      max-width: 1500px;
      margin: 0 auto;
      padding: 0 15px;
  }
  
  /* 古典风格边框与阴影 */
  .classic-border {
      border: 1px solid #c9b18b;
      border-radius: 3px;
      box-shadow: 0 4px 8px rgba(92, 58, 33, 0.1);
  }
  
  .classic-bg {
      background-color: #fffaf0;
      border: 1px solid #d4c4a8;
  }
  
  /* 第二区域：全站搜索区 */
  .search-section {
      padding: 25px 0; /* 减少上下内边距，使搜索框更靠近虚线 */
      background-color: #D7B974; /* 修改为要求的背景色 */
      border-bottom: 2px dashed #8b4513; /* 加深分割虚线颜色 */
      position: relative;
  }
  
  .search-container {
      display: flex;
      flex-direction: column;
      align-items: center;
  }
  
  .search-box {
      display: flex;
      width: 100%;
      max-width: 800px;
      margin-bottom: 0; /* 移除底部外边距 */
  }
  
  .search-icon {
      background-color: #8b4513;
      color: #f5deb3;
      padding: 15px 20px;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      font-size: 1.2rem;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
  }
  
  .search-input >>> .el-input__inner {
      padding: 18px;
      border: 1px solid #c9b18b;
      border-left: none;
      border-right: none;
      font-size: 1rem;
      font-family: 'Noto Serif SC', serif;
      background-color: #fffaf0;
      color: #5c3a21;
      min-width: 0; /* 防止flex布局溢出 */
      width: 100%;
      height: 100%;
      border-radius: 0;
  }
  
  .search-input >>> .el-input__inner::placeholder {
      color: #8b4513; /* 修改占位符颜色使其更明显 */
  }
  
  .search-input >>> .el-input__wrapper {
      padding: 0;
      border: none;
      border-radius: 0;
      background-color: #fffaf0;
      box-shadow: none;
  }
  
  .search-button {
      background-color: #a0522d;
      color: #f5deb3;
      border: none;
      padding: 0 25px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      cursor: pointer;
      font-size: 1rem;
      font-family: 'Noto Serif SC', serif;
      font-weight: 600;
      transition: background-color 0.3s;
      flex-shrink: 0;
      height: auto;
  }
  
  .search-button:hover {
      background-color: #8b4513;
  }
  
  .search-tags {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 12px;
      max-width: 900px;
  }
  
  .search-tag {
      background-color: #fffaf0;
      border: 1px solid #c9b18b;
      padding: 8px 18px;
      border-radius: 20px;
      font-size: 0.9rem;
      color: #5c3a21;
      cursor: pointer;
      transition: all 0.3s;
  }
  
  .search-tag:hover {
      background-color: #8b4513;
      color: #f5deb3;
      border-color: #8b4513;
  }
  
  .search-tag.more-tag {
      background-color: #e6d3b3;
      border: 1px solid #a0522d;
      color: #8b4513;
      font-weight: 600;
  }

  /* 响应式设计 */
  @media (max-width: 1200px) {
      .books-grid-five {
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
      }
  }
  
  @media (max-width: 992px) {
      .books-grid-five {
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
      }
      
      .custom-modal >>> .el-dialog {
          width: 95%;
      }
      
  }
  
  @media (max-width: 768px) {
      /* 搜索框不换行 */
      .search-box {
          flex-direction: row;
          overflow: hidden;
      }
      
      .search-icon, .search-input, .search-button {
          border-radius: 0;
          border: 1px solid #c9b18b;
          margin: 0;
          width: auto;
          flex-shrink: 0;
          height: 54px;     /**20260108,增加高度的约定，和搜索界面上的搜索框高度保持一致 */
      }
      
      .search-icon {
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;
          text-align: center;
          padding: 15px;
          width: 50px;
      }

      /* 20260108,中间输入框自动延展占据剩余宽度空间。此处设置后，下面更小宽度页码的也生效 */
      .search-input {
         flex: 1;         /* 关键：占据剩余空间 */
         min-width: 0;    /* 允许缩小 */
      }
      
      .search-input >>> .el-input__inner {
          flex: 1;
          min-width: 0;
          border-left: none;
          border-right: none;
          padding: 15px 10px;
      }
      
      .search-button {
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          padding: 15px 20px;
          white-space: nowrap;
      }
      
      /* 隐藏搜索标签 */
      .search-tags {
          display: none;
      }

  }
  
  @media (max-width: 576px) {
      /* 小屏幕每行显示2本书 */
      .books-grid-five {
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
      }
      
      /* 手机上进一步优化搜索框 */
      .search-icon {
          width: 45px;
          padding: 12px;
      }
      
      .search-button {
          padding: 12px 15px;
          font-size: 0.9rem;
      }
      
      .search-input >>> .el-input__inner {
          padding: 12px 8px;
          font-size: 0.9rem;
      }
      
  }
  
  @media (max-width: 400px) {
      /* 超小屏幕每行显示2本书 */
      .books-grid-five {
          grid-template-columns: repeat(2, 1fr);
          gap: 10px;
      }
      
      /* 超小屏幕搜索框优化 */
      .search-icon {
          width: 40px;
          padding: 10px;
          font-size: 1rem;
      }
      
      .search-button {
          padding: 10px 12px;
          font-size: 0.85rem;
      }

      .search-input >>> .el-input__inner {
          padding: 10px 6px;
          font-size: 0.85rem;
      }
      
  }
  
  /* 古典印章样式 */
  .seal-style {
      display: inline-block;
      padding: 5px 10px;
      background-color: #8b4513;
      color: #f5deb3;
      border-radius: 3px;
      font-size: 0.8rem;
      font-family: 'Noto Serif SC', serif;
      letter-spacing: 1px;
  }
  </style>


// WEBPACK FOOTER //
// src/views/atopsearch/index.vue